import IMAdjustment from './IMAdjustment';

export default IMAdjustment;
